import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { FormUtilsService } from '../../shared/services/form-utils.service';
import { FormsUtils } from '../../shared/forms.utils';
import { Field } from '../interfaces/hubspot-form-data';

// @dynamic
@Injectable()
export class CustomInputEmailValidator {
    static ValidateEmailAndCheckResubscribe(field: Field, utilsService: FormUtilsService): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            // tslint:disable-next-line:max-line-length
            const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const trimmedValue = FormsUtils.trim(control.value);
            if (control.value) {
                if ('' === control.value || '' === trimmedValue) {
                    return { email: { valid: false, required: true } } || null;
                }

                if (!emailRegex.test(control.value)) {
                    return { email: { valid: false, messageKey: 'invalidEmailFormat', type: 'INVALID_EMAIL' } } || null;
                }
            }
        };
    }
}
